import { render } from "./DynamicAvatar.vue?vue&type=template&id=7bb3a3d0&ts=true"
import script from "./DynamicAvatar.vue?vue&type=script&lang=ts"
export * from "./DynamicAvatar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicAvatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bb3a3d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bb3a3d0', __exports__)) {
    api.reload('7bb3a3d0', __exports__)
  }
  
  module.hot.accept("./DynamicAvatar.vue?vue&type=template&id=7bb3a3d0&ts=true", () => {
    api.rerender('7bb3a3d0', render)
  })

}


export default __exports__